import { centerable, uploadable } from '../decorators';
import { BLOCK_CLASSES } from '@intercom/embercom-prosemirror-composer/lib/blocks/constants';
export const imageTextCssClasses = {
  element: BLOCK_CLASSES.imageText,
  image: `${BLOCK_CLASSES.imageText}-image`,
  imageContainer: `${BLOCK_CLASSES.imageText}-image-container`,
  description: `${BLOCK_CLASSES.imageText}-description`,
  textContainer: `${BLOCK_CLASSES.imageText}-text-container`,
  title: `${BLOCK_CLASSES.imageText}-title`
};
export const imageTextSpec = centerable(uploadable({
  inline: false,
  attrs: {
    type: {
      default: 'imageText'
    },
    imageUrl: {
      default: ''
    },
    text: {
      default: ''
    },
    title: {
      default: ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: imageTextCssClasses.element,
    getAttrs(dom) {
      let img = dom.querySelector(`.${imageTextCssClasses.image}`);
      let title = dom.querySelector(`.${imageTextCssClasses.title}`);
      let text = dom.querySelector(`.${imageTextCssClasses.description}`);
      return {
        imageUrl: img.getAttribute('src'),
        title: title.textContent,
        text: text.textContent
      };
    }
  }],
  toDOM(node) {
    let {
      imageUrl,
      text,
      title
    } = node.attrs;
    return ['div', {
      class: imageTextCssClasses.element,
      'data-type': 'imageText'
    }, ['div', {
      class: imageTextCssClasses.imageContainer
    }, ['img', {
      src: imageUrl,
      alt: text,
      class: imageTextCssClasses.image
    }]], ['div', {
      class: imageTextCssClasses.textContainer
    }, ['div', {
      class: imageTextCssClasses.title
    }, ['b', {}, title]], ['div', {
      class: imageTextCssClasses.description
    }, text]]];
  }
}));
export function cleanImageTextFromElement(node) {
  let elements = node.querySelectorAll(`.${BLOCK_CLASSES.imageText}`);
  elements.forEach(element => {
    element.remove();
  });
}